var exports = {
  "kL": "x43aef4ae--3e57f2--container",
  "Ki": "x43aef4ae--3e57f2--video",
  "W_": "x43aef4ae--3e57f2--poster",
  "W5": "x43aef4ae--3e57f2--poster--hidden",
  "eo": "x43aef4ae--3e57f2--poster-image",
};

module.exports = exports;
